import * as THREE from "three";
import Experience from "../Experience.js";

export default class Mug {
  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;
    this.time = this.experience.time;
    this.debug = this.experience.debug;

    // Debug
    if (this.debug.active) {
      this.debugFolder = this.debug.ui.addFolder("Mug");
    }

    // Resource
    this.resource = this.resources.items.mugModel;

    this.setModel();
  }

  setModel() {
    this.model = this.resource.scene;
    this.model.position.set(0.15, -0.346, 0.37);
    this.model.name = "mug";
    this.mug = this.model.children[0];
    this.coffee = this.model.children[0].children[0];
    this.coffee.name = "coffee";
    this.coffee.empty = false;
    this.mug.material.color.set("#167CAC");
    this.coffee.material.color.set("#8b5138");
    this.scene.add(this.model);

    this.model.traverse((child) => {
      if (child instanceof THREE.Mesh) {
        child.castShadow = true;
        child.name = this.model.name;
      }
    });
  }

  update() {
    // console.log(this.coffee.empty);
    if (this.coffee.position.y > 0.03 && this.coffee.empty) {
      this.coffee.position.y -= this.time.delta * 0.000007;
    }
  }
}
